import { useQuery } from '@tanstack/react-query';
import type { Form4OverrideState } from '@munifocus/contracts-gov';
import { api } from './api-client';

/**
 * Step 5.1 Form 4 fields — the values pre-populated from the file record, plus
 * the log of every per-field override recorded against a generated notice.
 *
 * Read-only: overrides are written as part of a Form 4 generation event (the
 * officer's edits ride along with the generate request), never on their own.
 */
export async function getForm4Overrides(fileId: string): Promise<Form4OverrideState> {
  const { data } = await api.get<Form4OverrideState>(`/files/${fileId}/form4-overrides`);
  return data;
}

export const form4OverrideKeys = {
  byFile: (fileId: string) => ['form4-overrides', fileId] as const,
};

export function useForm4Overrides(fileId: string | undefined) {
  return useQuery({
    queryKey: form4OverrideKeys.byFile(fileId ?? ''),
    queryFn: () => getForm4Overrides(fileId as string),
    enabled: !!fileId,
  });
}
